export default "__VITE_ASSET__SnuEd$BT__"